import { File } from 'lucide-react'
import { useDropzone } from 'react-dropzone'

const ALLOWED_IMAGE_FORMATS = {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
    'image/gif': ['.gif'],
    'image/webp': ['.webp'],
}

const ALLOWED_VIDEO_FORMATS = {
    'video/mp4': ['.mp4'],
    'video/webm': ['.webm'],
    'video/ogg': ['.ogg'],
    'video/quicktime': ['.mov'],
}

const getAllowedFormats = (campaignFormat) => {
    if (campaignFormat === 'singleImage') return ALLOWED_IMAGE_FORMATS
    if (campaignFormat === 'video') return ALLOWED_VIDEO_FORMATS

    return {
        ...ALLOWED_IMAGE_FORMATS,
        ...ALLOWED_VIDEO_FORMATS,
    }
}

const DropZone = ({ onDrop, allowMultiple, campaignFormat }) => {
    const allowedFormats = getAllowedFormats(campaignFormat)
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: allowedFormats,
        multiple: allowMultiple,
    })

    return (
        <div {...getRootProps()} style={dropZoneStyles(isDragActive)}>
            <input {...getInputProps()} />
            <div>
                <div className="d-flex align-items-center gap-3">
                    <div
                        style={{
                            backgroundColor: '#3B5168',
                            borderRadius: '20px',
                            height: '40px',
                            width: '40px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                        }}
                    >
                        <File size={20} />
                    </div>
                    <div style={{ fontSize: 14 }}>
                        <p className="fw-semibold" style={{ margin: 0 }}>
                            Choose {allowMultiple ? 'files' : 'a file'} or drag & drop {allowMultiple ? 'them' : 'it'}{' '}
                            here
                        </p>
                        <p style={{ color: '#899CBD', margin: 0 }}>
                            Supported formats:{' '}
                            {Object.values(allowedFormats)
                                .map((format) => format[0])
                                .map((format) => format.toUpperCase().replace('.', ''))
                                .join(', ')}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

const dropZoneStyles = (isDragActive) => ({
    padding: '32px 24px',
    borderRadius: 2,
    cursor: 'pointer',
    transition: 'border-color 0.3s ease',
    borderColor: isDragActive ? '#007bff' : '#3B5168',
    backgroundColor: isDragActive ? 'rgba(0, 123, 255, 0.05)' : '#17273C',
})

export default DropZone
